import { Outlet, RouteObject } from "react-router-dom";
import WelcomePage from "../pages/welcomePage";
import { DomainProvider } from "@4uhub/lib4uhub";
import DashBoardPanelsPage from "../pages/4uSpots/myDashboards/Panels/DashBoardPanels";
import DashBoardPanel from "../pages/4uSpots/myDashboards/Panels/DashBoardPanelForm/DashBoardPanel";
import Panel from "../pages/4uSpots/myDashboards/Panels/Panel";
import ExecutionsPage from "../pages/4uSpots/myDashboards/Executions/ExecutionsPage";
import ExecutionDetailPage from "../pages/4uSpots/myDashboards/Executions/ExecutionDetail/ExecutionDetailPage";
import GenerateConfigPage from "../pages/4uSpots/myDashboards/GenerateConfig/GenerateConfigPage";
import ReportExecutionPage from "../pages/4uSpots/Reports/ReportExecution/ReportExecutionPage";
import ReportResultPage from "../pages/4uSpots/Reports/ReportExecution/ReportResultPage";
import ReportsPage from "../pages/4uSpots/Reports/ReportsPage";

const spotsRoutes: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "myDashboards",
    element: <Outlet />,
    children: [
      {
        path: "dashboards",
        element: (
          <DomainProvider value={{ domainName: "dashboardcomponent" }}>
            <DashBoardPanelsPage />
          </DomainProvider>
        ),
      },
      {
        path: "dashboards/new",
        element: (
          <DomainProvider
            value={{ domainName: "dashboardcomponent" }}
            actions={["Create"]}
          >
            <DashBoardPanel />
          </DomainProvider>
        ),
      },
      {
        path: "dashboards/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "dashboardcomponent" }}
            actions={["Read"]}
          >
            <DashBoardPanel />
          </DomainProvider>
        ),
      },
      {
        path: "dashboards/panel/:panelId",
        element: (
          <DomainProvider value={{ domainName: "dashboardcomponent" }}>
            <Panel />
          </DomainProvider>
        ),
      },
      {
        path: "view",
        element: (
          <DomainProvider value={{ domainName: "panels" }}>
            <DashBoardPanelsPage isView />
          </DomainProvider>
        ),
      },
      {
        path: "view/panel/:panelId",
        element: (
          <DomainProvider value={{ domainName: "panels" }}>
            <Panel isView />
          </DomainProvider>
        ),
      },
      {
        path: "executions",
        element: (
          <DomainProvider value={{ domainName: "panels" }}>
            <ExecutionsPage />
          </DomainProvider>
        ),
      },
      {
        path: "executions/:id",
        element: (
          <DomainProvider value={{ domainName: "panels" }} actions={["Read"]}>
            <ExecutionDetailPage />
          </DomainProvider>
        ),
      },
      {
        path: "generateConfig",
        element: (
          <DomainProvider
            value={{ domainName: "dashboardgenerateconfig" }}
            actions={["Read"]}
          >
            <GenerateConfigPage />
          </DomainProvider>
        ),
      },
    ],
  },
  {
    path: "reports",
    element: <Outlet />,
    children: [
      {
        path: "view/2",
        element: (
          <DomainProvider value={{ domainName: "internalreports" }}>
            <ReportsPage typeId="2" />
          </DomainProvider>
        ),
      },
      {
        path: "view/:typeId",
        element: (
          <DomainProvider value={{ domainName: "reports" }}>
            <ReportsPage />
          </DomainProvider>
        ),
      },
      {
        path: `view/2/report/:reportId`,
        element: (
          <DomainProvider value={{ domainName: "internalreports" }}>
            <ReportExecutionPage />
          </DomainProvider>
        ),
      },
      {
        path: `view/2/report/:reportId/result`,
        handle: {
          layout: "report",
        },
        element: (
          <DomainProvider value={{ domainName: "internalreports" }}>
            <ReportResultPage />
          </DomainProvider>
        ),
      },
      {
        path: "view/:typeId/report/:reportId",
        element: (
          <DomainProvider value={{ domainName: "reports" }}>
            <ReportExecutionPage />
          </DomainProvider>
        ),
      },
      {
        path: "view/:typeId/report/:reportId/result",
        handle: {
          layout: "report",
        },
        element: (
          <DomainProvider value={{ domainName: "reports" }}>
            <ReportResultPage />
          </DomainProvider>
        ),
      },
    ],
  },
];

export default spotsRoutes;
